import React, { FC, useEffect, useState } from "react";
import { Select } from "antd";

const { Option } = Select;

const moment = require('moment');
const TimePicker = (props)=> {
    const {beginLimit, value, onChange, name} = props;
    const [selectOptions, setSelectOptions] = useState([]);
    const [defaultValue, setDefaultValue] = useState();


	const isEarlierThanEndLimit = (timeValue, endLimit, lastValue) => {
		let timeValueIsEarlier = moment(timeValue, 'h:mmA').diff(moment(endLimit, 'h:mmA')) < 0
		let timeValueIsLaterThanLastValue = lastValue === undefined ? true : moment(lastValue, 'h:mmA').diff(moment(timeValue, 'h:mmA')) < 0
		return timeValueIsEarlier && timeValueIsLaterThanLastValue;
	};

    const setHours = (dt, h) =>  {
        var s = /(\d+):(\d+)(.+)/.exec(h);
        dt.setHours(s[3] === "PM" ? 
          12 + parseInt(s[1], 10) : 
          parseInt(s[1], 10));
        dt.setMinutes(parseInt(s[2],10));
        return dt;
    }
      
    useEffect(() => {
        let timeValue = beginLimit || "12:00AM";
		let lastValue;
        let endLimit = props.endLimit || "11:59PM";
		let step = props.step || 15;
		let options = [];
		options.push(<option key={timeValue} value={timeValue}>{timeValue}</option>);

        while ( isEarlierThanEndLimit(timeValue, endLimit, lastValue) ) {
                lastValue = timeValue;
                timeValue = moment(timeValue, 'h:mmA').add(step, 'minutes').format('h:mmA');
                options.push(timeValue);
            }
        setSelectOptions(options);

        }, []);

        useEffect(() => {
            if(value){
                setDefaultValue(value.format('h:mmA'))
            }
    
            }, [value]);
    



    return(
        <Select className="w-full" placeholder={name} value={defaultValue} onChange={(value)=>{
            onChange(setHours(new Date(), value))
        }}>
              {selectOptions.map((option, idx: number) => (
                <Option key={option}>{option}</Option>
              ))}
        </Select>
      )
};

export default TimePicker;
